import Image from 'app/Components/Shared/Image/image';
import React from 'react'
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import './error.scss';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers';

const MainErrorPage = (props) => {
  return (
    <>
      <div className='error-page-otp'>
        <div className='error-img'>
          <Image src={require('./images/error-logo.svg')} />
        </div>
        <div className='error-msg'>
          <div dangerouslySetInnerHTML={{ __html: props.iContent?.title?.value }}></div>
        </div>

        <div>
          <a className='join-btn' onClick={() => {
            prepareUrl(props.iContent?.buttonLink?.value, props.context)
          }}>{props.iContent?.buttonTitle?.value}</a>
        </div>
        <BtnWhite
          style={{ height: '50px' }}
          className='h-50'
          text={'לעמוד הבית'}
          onclick={() => prepareUrl('', props.context)}
        />
      </div>
    </>
  );
}

export default MainErrorPage